<template>
    <svg v-if="flags && flags.includes(code)" class="country-flag" width="19" height="14" viewBox="0 0 22 16" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin">
        <use :xlink:href="flagId"></use>
    </svg>
    <icon-flag v-else/>
</template>

<script>
import IconFlag from './icons/iconFlag';
import {availableFlags} from '../consts';
export default {
    name: "CountryFlag",
    components: {IconFlag},
    props: ['code'],
    data() {
        return {
            flags: availableFlags
        }
    },
    computed: {
        flagId() {
            return `#${this.code.toLowerCase()}`
        }
    }
}
</script>

<style lang="scss">
    .country-flag {
        border-radius: 2px;
    }
</style>
